export const JP_FAQ = 'https://sailjp.helte.jp/faq/';
export const PATH_JP_BILLING = '/teachers/billing';
export const PATH_WORLD_BILLING = '/students/billing';
